import React, { useState } from "react";
import styled from "styled-components";
import { push } from "connected-react-router";
import { connect } from "react-redux";

import appUrls from "../../config/appUrls";
import SmallDropdownIcon from "../../components/icons/DropdownSmall";
import ServicesDropdownIcon from "../../components/icons/ServicesDropdown";
import Button from "../../components/Button";
import Textfield from "../../components/TextField";
import {
  RightContainer,
  TitleAction,
  TextContainer,
  ZoomedTitle as Title,
  ZoomedActionsContainer as ActionsContainer,
  DropDownButton,
  SwitchButtonsWrap,
  SwitchButton,
  ActionsTitle,
  SecondActionsTitle
} from "../../components/StyledComponents";
import CloseIcon from "../../components/icons/Close";

const GraphOptions = props => {
  const [chosen, setChosen] = useState(1);
  return (
    <RightContainer>
      <TitleAction>
        <CloseIcon onClick={() => props.push(appUrls.HOME)} />
        <TextContainer>
          <span>قناة</span>
          <Title>340,000 معاملة</Title>
        </TextContainer>
      </TitleAction>
      <ActionsContainer>
        <ActionsTitle>الخدمات المقدمة</ActionsTitle>
        <p>
          هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي
        </p>
        <DropDownButton
          size="small"
          open={false}
          // onClick={() => this.handleDropdown("dropDownOneOpen")}
          outlined
        >
          <SmallDropdownIcon
          // open={dropDownOneOpen}
          />
          <span> قنوات تقديم عبر الانترنت</span>
        </DropDownButton>
        <DropDownButton
          size="small"
          open={false}
          // onClick={() => this.handleDropdown("dropDownTwoOpen")}
          outlined
        >
          <SmallDropdownIcon
          // open={dropDownTwoOpen}
          />
          <span> مواقع إلكترونية</span>
        </DropDownButton>
        <SecondActionsTitle>تصنيف الخدمات</SecondActionsTitle>
        <SwitchButtonsWrap>
          <SwitchButton
            // onClick={() => this.handleChosen(1)}
            outlined
          >
            عامة
          </SwitchButton>
          <SwitchButton
            // onClick={() => this.handleChosen(2)}
            outlined={false}
          >
            رئيسية
          </SwitchButton>
        </SwitchButtonsWrap>

        <Textfield
          placeholder="بحث بإسم الخدمة"
          rounded
          icon={<ServicesDropdownIcon />}
        />
      </ActionsContainer>
    </RightContainer>
  );
};

export default connect(
  null,
  { push }
)(GraphOptions);
